import { render, staticRenderFns } from "./drag-mask.vue.js?vue&type=template&id=4dfbfbdc&scoped=true!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=template&id=4dfbfbdc&scoped=true"
import script from "./drag-mask.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=script&lang=js"
export * from "./drag-mask.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=script&lang=js"
import style0 from "./drag-mask.vue.scss?vue&type=style&index=0&id=4dfbfbdc&scoped=true&lang=scss!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=style&index=0&id=4dfbfbdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfbfbdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfbfbdc')) {
      api.createRecord('4dfbfbdc', component.options)
    } else {
      api.reload('4dfbfbdc', component.options)
    }
    module.hot.accept("./drag-mask.vue.js?vue&type=template&id=4dfbfbdc&scoped=true!=!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./drag-mask.vue?vue&type=template&id=4dfbfbdc&scoped=true", function () {
      api.rerender('4dfbfbdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/ChatFrame/ChatExtract/components/drag-mask.vue"
export default component.exports